export {
  IIOutreachTemplateCreate,
  IIOutreachTemplateUpdate,
  IOutreachTemplate,
  IOutreachTemplateBase,
} from './models/outreach-templates.models';
export { OutreachTemplatesService } from './services/outreach-templates.service';
export * from './testing/outreach-templates.mock';
